import { defineComponent as x, computed as u, openBlock as l, createElementBlock as o, normalizeClass as n, createElementVNode as g, normalizeStyle as v, Fragment as h, renderList as C, toDisplayString as b, createCommentVNode as i } from "vue";
const w = {
  key: 0,
  class: "base-progress-bar__segment-label"
}, S = {
  key: 3,
  class: "base-progress-bar__legend"
}, F = { class: "base-progress-bar__legend-label" }, L = { class: "base-progress-bar__legend-value" }, E = /* @__PURE__ */ x({
  __name: "BaseProgressBar",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    variant: { default: "default" },
    showLabel: { type: Boolean, default: !1 },
    label: {},
    strengthScore: {},
    trackColorClass: { default: "bg-bg-bg-surface" },
    fillColorClass: { default: "bg-blue-blue800-deep" },
    segments: { default: () => [] },
    showLegend: { type: Boolean, default: !1 },
    showGap: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, p = u(() => e.variant === "password-strength" ? ((e.strengthScore || 0) + 1) * 20 : Math.min(Math.max(e.value / e.max * 100, 0), 100)), m = u(() => {
      if (e.variant === "password-strength") {
        const r = e.strengthScore || 0;
        return [
          "bg-red-red800",
          // 0: 매우 약함
          "bg-[#FF9500]",
          // 1: 약함
          "bg-primary-primary800",
          // 2: 보통
          "bg-[#7ED428]",
          // 3: 강함
          "bg-green-green800"
          // 4: 매우 강함
        ][r];
      }
      return e.fillColorClass;
    }), _ = u(() => {
      if (e.variant === "password-strength") {
        const r = e.strengthScore || 0;
        return [
          "text-red",
          // 0: 매우 약함
          "text-[#FF9500]",
          // 1: 약함
          "text-primary",
          // 2: 보통
          "text-[#7ED428]",
          // 3: 강함
          "text-green"
          // 4: 매우 강함
        ][r];
      }
      return "text-default";
    }), y = u(() => {
      if (e.label) return e.label;
      if (e.variant === "password-strength") {
        const r = ["매우 약함", "약함", "보통", "강함", "매우 강함"];
        return r[e.strengthScore || 0] || r[0];
      } else if (e.variant === "performance")
        return;
      return `${Math.round(p.value)}%`;
    }), f = [
      "bg-blue-blue800-deep",
      "bg-primary-primary800",
      "bg-green-green800",
      "bg-[#FF9500]",
      "bg-red-red800",
      "bg-[#7ED428]",
      "bg-purple-purple800",
      "bg-yellow-yellow800"
    ], d = u(() => {
      if (e.variant !== "stacked" || !e.segments || e.segments.length === 0)
        return [];
      const r = e.segments.reduce((s, a) => s + a.value, 0);
      return r === 0 ? [] : e.segments.map((s, a) => ({
        ...s,
        percentage: s.value / r * 100,
        colorClass: s.colorClass || f[a % f.length]
      }));
    }), k = (r, s) => s === 1 ? "6px" : r === 0 ? "6px 0 0 6px" : r === s - 1 ? "0 6px 6px 0" : "0";
    return (r, s) => (l(), o("div", {
      class: n(["base-progress-bar", [`base-progress-bar--${t.variant}`]])
    }, [
      t.variant !== "stacked" ? (l(), o("div", {
        key: 0,
        class: n(["base-progress-bar__track", t.trackColorClass])
      }, [
        g("div", {
          class: n(["base-progress-bar__fill", m.value]),
          style: v({
            width: `${p.value}%`,
            borderRadius: e.variant === "performance" ? "999px 0 0 999px" : "999px"
          })
        }, null, 6)
      ], 2)) : (l(), o("div", {
        key: 1,
        class: n(["base-progress-bar__track base-progress-bar__track--stacked", t.trackColorClass])
      }, [
        (l(!0), o(h, null, C(d.value, (a, c) => (l(), o("div", {
          key: c,
          class: n(["base-progress-bar__segment", a.colorClass]),
          style: v({
            width: `${a.percentage}%`,
            borderRadius: k(c, d.value.length)
          })
        }, [
          a.showLabel ? (l(), o("span", w, b(a.label || `${a.percentage.toFixed(1)}%`), 1)) : i("", !0)
        ], 6))), 128))
      ], 2)),
      t.showLabel && t.variant !== "stacked" ? (l(), o("div", {
        key: 2,
        class: n(["base-progress-bar__label", [`base-progress-bar__label--${t.variant}`, _.value]])
      }, b(y.value), 3)) : i("", !0),
      t.variant === "stacked" && t.showLegend ? (l(), o("div", S, [
        (l(!0), o(h, null, C(d.value, (a, c) => (l(), o("div", {
          key: c,
          class: "base-progress-bar__legend-item"
        }, [
          g("span", {
            class: n(["base-progress-bar__legend-color", a.colorClass])
          }, null, 2),
          g("span", F, b(a.label || `항목 ${c + 1}`), 1),
          g("span", L, b(a.value) + " (" + b(a.percentage.toFixed(1)) + "%) ", 1)
        ]))), 128))
      ])) : i("", !0)
    ], 2));
  }
});
export {
  E as default
};
